<template>
     <el-container class="pagination-list timing-task">
      <el-main>
        <div class="content">
          <el-form :inline="true" @submit.native.prevent>
            <el-form-item>
              <div class="operation">
                <el-input  prefix-icon="el-icon-search" v-model="conditions.keyword" placeholder="请输入名称/创建人" @keyup.enter.native="search" clearable/>
                <el-button class="search-button" @click="search">查询</el-button>
              </div>
            </el-form-item>
          </el-form >
            <div class="table-list">
              <el-table class="table-list" :data="items" v-loading="loading" height='100%'>
                <template  v-for="(col,index) in cols" >
                  <el-table-column :key="index"
                  :formatter="formatter"
                  :prop="col.prop" :label="col.label" align="center" show-overflow-tooltip
                  :min-width="col.width" :width="col.width">
                  </el-table-column>
                </template>
                  <el-table-column
                  fixed="right" label="操作" align="center" width="200px">
                    <template slot-scope="scope">
                      <el-button :disabled="btnClick" :class="{'close-row':scope.row.jobStatus}" type="text" @click="changeStatus(scope.row)">{{scope.row.jobStatus?'停用':'开启'}}</el-button>
                      <el-button type="text" @click="viewHistory(scope.row)">运行历史</el-button>
                      <el-button v-if="['process', 'notice'].includes(scope.row.jobType)" :disabled="btnClick" type="text" @click="openDialog(scope.row)">通知人</el-button>
                      <el-dropdown class="cust-dropdown" @command="handleCommand($event, scope.row)">
                        <span class="el-dropdown-link">
                          <i class="fa fa-chevron-circle-down"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item command="executeNow">立即执行</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </template>
                  </el-table-column>
                </el-table>
                <el-footer height="32px" class="pagination-footer">
                  <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pagination.currentPage"
                    :page-sizes="pagination.pageSizes"
                    :page-size="pagination.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="pagination.total">
                  </el-pagination>
                </el-footer>
           </div>
        </div>
    </el-main>
      <timing-history :parameter="historyParameter"></timing-history>
       <select-inform-people v-if="dialogParams.visable" :data="dialogParams" @getCandidate="getCandidate"></select-inform-people>
  </el-container>
</template>

<script>
import TimingHistory from './timing-history'
import SelectInformPeople from './select-inform-people'
export default {
  name: 'TimingTaskSystem',
  data () {
    return {
      historyParameter: {visable: false, id: ''},
      conditions: { keyword: '' },
      pagination: {currentPage: 1, pageSize: 20, pageSizes: [10, 20, 30, 50, 100], total: 0},
      loading: false,
      items: [],
      filters: {},
      cols: [
        {prop: 'jobName', label: '名称'},
        {prop: 'way', label: '执行方式', width: '300px'},
        {prop: 'jobType', label: '定时类型'},
        {prop: 'createTime', label: '创建时间'},
        {prop: 'createUser', label: '创建人'},
        {prop: 'operationTime', label: '最近运行时间', width: '160px'},
        {prop: 'result', label: '最近运行结果', width: '160px'},
        {prop: 'comment', label: '备注', width: '160px'},
        {prop: 'jobStatus', label: '当前状态'}
      ],
      dialogParams: {
        visable: false,
        data: [],
        formData: {},
        id: ''
      },
      btnClick: false
    }
  },
  components: {TimingHistory, SelectInformPeople},
  created () {
    this.getTableData()
  },
  methods: {
    search () {
      // 页数为 1
      this.pagination.currentPage = 1
      this.initParams()
    },
    initParams () {
      this.filters = {
        'keyword': this.conditions.keyword
      }
      this.getTableData()
    },
    getTableData () {
      this.loading = true
      let page = this.pagination
      let params = {
        'index': page.currentPage,
        'size': page.pageSize
      }
      params.filters = this.filters
      this.$axios.get('/task-api/quartz/jobRuHistoryList', {params})
        .then((res) => {
          // 页面数据改变重新统计数据数量和当前页
          this.pagination.total = res.data.total
          if (this.pagination.total && (this.pagination.currentPage - 1) * this.pagination.pageSize >= this.pagination.total) {
            this.pagination.currentPage--
            return
          }
          this.items = res.data.items
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
    },
    viewHistory (row) {
      this.historyParameter.id = row.jobId
      this.historyParameter.visable = true
    },
    handleSizeChange (val) {
      this.pagination.pageSize = val
      this.getTableData()
    },
    handleCurrentChange (val) {
      this.pagination.currentPage = val
      this.getTableData()
    },

    formatter (row, column) {
      let data = row[column.property]
      if (column.property === 'jobStatus') {
        return row.jobStatus ? '开启' : '停用'
      }
      if (column.property === 'way') {
        let field = `每隔${row.timeInterval}`
        switch (row.cycle) {
          case 'day':
            field = `${field}天`
            break
          case 'month':
            field = `${field}月`
            break
          case 'hour':
            field = `${field}小时`
            break
          case 'min':
            field = `${field}分`
            break
          case 'sec':
            field = `${field}秒`
            break
          case 'week':
            field = `${field}周`
            break
          case 'year':
            field = `${field}年`
            break
          case 'onetime':
            field = '只一次'
            break
        }
        return `从${row.startTime}开始${field}执行此动作`
      } else if (column.property === 'jobType') {
        return data === 'process' ? '定时发起流程' : '定时业务操作'
      }
      return data
    },
    async changeStatus (row) {
      this.btnClick = true
      if (!row.jobStatus && row.jobType === 'process') {
        // 开启的时候判断是否选了通知人
        let data = await this.getCandidateWithRow(row)
        if (!data.quartzProcessDesign.candidate || data.quartzProcessDesign.candidate.length === 0) {
          this.btnClick = false
          return this.$message.error('请先设置通知人')
        }
      }
      let tip = `你确定${row.jobStatus ? '停用' : '开启'}吗`
      // 修改状态后需要调用接口
      this.$confirm('', tip, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'publishMessageBox colorMessage',
        center: true
      }).then(() => {
        let url = row.jobStatus ? `/task-api/quartz/pause/${row.jobId}` : `/task-api/quartz/start/${row.jobId}`
        return this.$axios.get(url)
      })
        .then(res => {
          this.btnClick = false
          this.getTableData()
        }).catch(() => {
          this.btnClick = false
        })
    },
    async openDialog (row) {
      const getCandidate = {
        process: (data) => {
          return data.quartzProcessDesign.candidate
        },
        notice: (data) => {
          return data.quartzNoticeDesign.noticeUsers
        }
      }
      this.btnClick = true
      let data = await this.getCandidateWithRow(row)
      this.dialogParams.formData = this.$_.cloneDeep(data)
      this.dialogParams.data = getCandidate[row.jobType](data)
      this.dialogParams.id = row.jobId
      this.$nextTick(() => {
        this.dialogParams.visable = true
        this.btnClick = false
      })
    },
    async getCandidateWithRow (row) {
      return (await this.$axios.get(`/task-api/job/${row.jobId}`)).data
    },
    getCandidate (data) {
      if (data.length === 0) {
        return this.$message.error('通知人不能为空')
      }
      let jobType = 'process'
      if (this.dialogParams.formData && this.dialogParams.formData.jobType === 'notice') {
        jobType = 'notice'
      }
      this.$axios.post(`/task-api/quartz/${jobType}/${this.dialogParams.id}`, data).then(res => {
        this.$set(this, 'dialogParams', {visable: false, data: [], formData: {}, id: ''})
      })
    },
    executeNow (row) {
      this.$axios.get(`/task-api/quartz/immediately/${row.jobId}`)
    },
    handleCommand (e, row) {
      this[e](row)
    }
  },
  watch: {
    'historyParameter.visable' (val) {
      // 关闭弹框，刷新列表
      if (!val) {
        this.getTableData()
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/common.scss';
.timing-task {
  .el-main {
    >.content .operation .el-input {
      width: 384px;
    }

    .operation-buttons {
      .el-button {
        padding: 5px 10px;
      }
    }

    .table-list {
      border-right: 1px solid #ebebeb;
      .el-dropdown-link{
        margin: 0;
      }
      .el-table__fixed {
        background: #fff;
        box-shadow: none;
      }
      .close-row {
        color: #EE5451;

        &:hover {
          color: #FB9391;
        }

        &:active {
          color: #FB9391;
        }
      }
      .el-table__fixed-right {
        box-shadow: none;
        .el-table__fixed-header-wrapper{
          tr th:nth-last-of-type(1){
            border-right: none;
          }
       }
     }
  .el-table__fixed-right-patch{
    background-color: #f8f8f8;
  }
    }
  }
}
.colorMessage {
  .el-message-box__title span{
    color: #333;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/system/system/timing-task-system.vue